import { SmartTable } from '../../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor() {
    }

    $onInit() {
        this.st = new SmartTable();
        this.allItems = [...this.allUsers, ...this.hardTokens]
            .filter(({companyUserId}) => !companyUserId);
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/all-users/all-users.controller.js